import { render } from "./Peroid.vue?vue&type=template&id=5bd16f0c&scoped=true"
import script from "./Peroid.vue?vue&type=script&lang=js"
export * from "./Peroid.vue?vue&type=script&lang=js"

import "./Peroid.vue?vue&type=style&index=0&id=5bd16f0c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd16f0c"]])

export default __exports__